module.exports = __webpack_public_path__ + "static/media/think-out-of-the-box.c0c0a9c9.md";